// This is just for the Loading or Error Selector
export const GET_MACHINES = 'GET_MACHINES';

// Use these for Actions
export const GET_MACHINES_REQUEST = 'GET_MACHINES_REQUEST';
export const GET_MACHINES_SUCCESS = 'GET_MACHINES_SUCCESS';
export const GET_MACHINES_ERROR = 'GET_MACHINES_ERROR';
